const QUERY_KEYS = {
  DATA_KEY: "data",
  DATA_SOURCE: "dataSource",
  VARIABLES: "VARIABLES",
  TRANSLATIONS: "translations",
  GOALS: "goals"
};
export {
  QUERY_KEYS
};
